import React, {useEffect, useState} from 'react';

import ChildOutcomesTableRowReviewOnly2 from "./ReactChildOutcomesTableRowReviewOnly2";
import SpinnerDiv from "ui/SpinnerDiv";

const TITLES =
{
	edit:
		[
			{data_field: 'dmy_date_set', text: 'Date Set', keyName: 'k1', className: 'col-md-1', style: null },
			{data_field: 'dmy_date_achieved', text: 'Date Achieved', keyName: 'k2', className: 'col-md-1', style: null },
			{data_field: 'detail', text: 'Target', keyName: 'k3', className: 'col-md-8', style: {borderRightStyle: 'solid', borderRightColor: 'lightgrey', borderRightWidth: '1px'} },
			{data_field: 'actions', text: 'Actions', keyName: 'k4', className: 'col-md-2', style: {textAlign: 'center'} },
		] ,
			create:
	[
		{data_field: 'detail', text: 'Target', keyName: 'k1', className: 'col-md-12', style: null },
	] ,
		qa:
	[
		{data_field: 'dmy_date_set', text: 'Date Set', keyName: 'k1', className: 'col-md-1', style: null },
		{data_field: 'dmy_date_achieved', text: 'Date Achieved', keyName: 'k2', className: 'col-md-1', style: null },
		{data_field: 'detail', text: 'Target', keyName: 'k3', className: 'col-md-8', style: {borderRightStyle: 'solid', borderRightColor: 'lightgrey', borderRightWidth: '1px'} },
		{data_field: 'actions', text: 'Actions', keyName: 'k4', className: 'col-md-2', style: {textAlign: 'center'} },
	] ,
		review:
	[
		{data_field: 'dmy_date_set', text: 'Date Set', keyName: 'k1', className: 'col-md-1', style: { paddingLeft: '30px'} },
		{data_field: 'dmy_date_achieved', text: 'Date Achieved', keyName: 'k2', className: 'col-md-1', style: { paddingLeft: '25px'} },
		{data_field: 'detail', text: 'Target', keyName: 'k2', className: 'col-md-1', style: { paddingLeft: '35px'} },
	] ,
default:
	[
		{data_field: 'dmy_date_set', text: 'Date Set', keyName: 'k1', style: null },
		{data_field: 'dmy_date_achieved', text: 'Date Achieved', keyName: 'k2', style: null },
		{data_field: 'detail', text: 'Target', keyName: 'k3', style: {borderRightStyle: 'solid', borderRightColor: 'lightgrey', borderRightWidth: '1px'} },
	]
}


const ChildOutcomesTableReviewOnly2 = ( props ) =>
{
	const [ data, setData ] = useState ( { loading: props.loading, data: props.data }) ;

	useEffect(() =>
	{
		setData ( { loading: false, data: props.data })

	}, [props.data]);

	const getTitlesForMode = ( mode ) =>
	{
		let titles = TITLES.default ;

		if ( TITLES[mode] != null )
		{
			titles = TITLES[mode] ;
		}

		return titles ;
	}

	const tableHeaderForMode = ( mode ) =>
	{
		const titles = getTitlesForMode( mode ) ;

		const lineList = titles.map ( value => {

			const className = value.className == null ? 'col-md-2' : value.className ;

			return React.createElement('div', {key: value.keyName, className: className, style: value.style }, value.text );
		}) ;

		return  React.createElement('div',{key:'trow', className: 'row'},
			React.createElement('div',{key:'tcol', className: 'col-md-12'},
				React.createElement('div',{key:'tcolrow', className: 'row'},lineList ))) ;
		
	}

	const onDelete = ( recordId ) =>
	{
		// If we were passed an onDelete function, then we are providing the data
		// from the container and need to cascade the trigger
		
		if ( props.onDelete != null )
		{
			props.onDelete ( recordId )
		}
		else
		{
			var newData = [] ;

			for (let i = 0; i < data.data.length; i++)
			{ 
				if ( data.data[i].cpp_id != recordId )
				{
					newData.push ( data.data[i])
				}
			}	

			setData ( { data: newData, loading: false}) ;
		}
	}

	const tableRows = () =>
	{
    	return data.data.map ( row => {

    		let mode =  props.mode ;

			const titles = getTitlesForMode( mode ) ;

			if (row.cpp_id != props.modifyRecordId && props.modifyRecordId != 0)
			{
				mode = 'view';
			}

				return <ChildOutcomesTableRowReviewOnly2
					authToken={props.authToken}
					allowChange={props.allowChange}
					key={'cpp' + row.cpp_id}
					data={row}
					ofr={props.ofr}
					child_id={props.child_id}
					onDelete={onDelete}
					onUpdate={props.onUpdate}
					onClose={props.onClose}
					onConfirmClose={props.onConfirmClose}
					onModify={props.onModify}
					onCancel={props.onModifyCancel}
					return_url={props.return_url}
					extended={props.extended}
					columns={titles}
					isSen={props.isSen}
					isPost16={props.isPost16}
					row={1}
					mode={mode} />
		})
	}

	const addItemRow = () =>
	{
		const titles = getTitlesForMode( 'create' ) ;

		return <ChildOutcomesTableRowReviewOnly2
			authToken={props.authToken}
			key={'cppadd'}
			data={null}
			ofr={props.ofr}
			child_id={props.child_id}
			onDelete={onDelete}
			onAddComplete={onAddComplete}
			onUpdate={props.onUpdate}
			onClose={props.onClose}
			onConfirmClose={props.onConfirmClose}
			onModify={props.onModify}
			onCancel={props.onCancelAdd}
			return_url={props.return_url}
			extended={props.extended}
			columns={titles}
			isSen={props.isSen}
			isPost16={props.isPost16}
			row={1}
			mode='create' />
	}

	const setAddMode = ( mode ) =>
	{
		props.setAddMode ( mode ) ;
	}

	const onCancelAdd = () =>
	{
		props.onCancelAdd() ;

		setAddMode (false) ;
	}

	const onAddComplete = ( rec ) =>
	{
		props.onAddComplete() ;

		let newData = data.data ;

		newData.unshift ( rec ) ;

		setData ( {loading: false, data: newData }) ;
	}

	const tableElement =  () =>
    {
		if ( data.data.length > 0 )
		{
			return (
				<div key='ReviewTablePanelBody3' className='panel-body' style={{ paddingBottom: '0px'}}>
					{ tableHeaderForMode( props.mode )}
					{ tableRows()}
					{ props.addMode === true && addItemRow() }
				</div>
			)
		}
		else
		{
			const showEmptyMessage = props.showEmptyMessage  ;

			return (
				<div key='ReviewTablePanelBody3' className='panel-body' style={{ paddingBottom: '0px'}}>
					{ props.addMode === true && addItemRow() }
					{ showEmptyMessage && <div key='ReviewTablePanelBody2' className='panel-body'>This pupil has no Targets set yet</div>}
					{ !showEmptyMessage && <div key='ReviewTablePanelBody2' className='panel-body'></div>}
				</div>
			)
		}
    }
        
	return data.loading === true ? <SpinnerDiv /> : tableElement() ;
}

export default ChildOutcomesTableReviewOnly2 ;
